import Uri from 'urijs';
import domainsService from '@clubmed/domains-service';

import config from 'Config';

export function getCurrentUri(req) {
  return new Uri(decodeURI(req.originalUrl)).protocol(req.protocol).host(req.get('host'));
}

export function isProduction() {
  return config.get('DEPLOYMENT_ENV') === 'production';
}

export function isStrictlyProductionEnv(cfg = config) {
  return (
    cfg.get('NODE_ENV') === 'production' &&
    (cfg.get('DEPLOYMENT_ENV') === 'production' || cfg.get('DEPLOYMENT_ENV') === 'prod')
  );
}

export function isStrictlyStagingEnv(cfg = config) {
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'staging';
}

export function isStrictlyIntegrationEnv(cfg = config) {
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'integration';
}

export function isStrictlyTestEnv(cfg = config) {
  return cfg.get('NODE_ENV') === 'test';
}

export function isStrictlyDevelopmentEnv(cfg = config) {
  return cfg.get('NODE_ENV') === 'development' || cfg.get('NODE_ENV') === 'dev';
}

export function getCurrentLocale(requestedLocale, hostname) {
  if (requestedLocale) {
    return requestedLocale;
  }
  const domainServiceForHostname = domainsService.forHostname(hostname);
  return domainServiceForHostname.getDefaultLocale();
}
